module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict4.95dc52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict4.png
// module id = XkpF
// module chunks = 0